/**
 * Copy for Claude's resume compaction dialog, shared by the server adapter
 * (which asks the question) and the web client (which recognizes the
 * question and its "never" answer in resolved user-input activities to
 * mirror the dismissal). Both sides must agree on these strings, so they
 * live here: reword the question or the answer label in this file only.
 */
export const CLAUDE_RESUME_COMPACTION_NEVER_ANSWER = "No volver a preguntar";
export const CLAUDE_RESUME_COMPACTION_QUESTION_HEADER = "Reanudar sesión";
export const CLAUDE_RESUME_COMPACTION_COMPACT_ANSWER = "Compactar y continuar";
export const CLAUDE_RESUME_COMPACTION_KEEP_ANSWER = "Mantener el historial completo";
export const CLAUDE_RESUME_COMPACTION_COMPACT_DESCRIPTION =
  "Reanudar con un resumen y usar menos tokens.";
export const CLAUDE_RESUME_COMPACTION_KEEP_DESCRIPTION = "Reanudar sin cambiar la conversación.";
export const CLAUDE_RESUME_COMPACTION_NEVER_DESCRIPTION =
  "Mantener el historial completo y omitir avisos futuros al reanudar.";

const CLAUDE_RESUME_COMPACTION_NEVER_ANSWER_EN = "Don't ask again";
const CLAUDE_RESUME_COMPACTION_QUESTION_HEADER_EN = "Resume session";
const CLAUDE_RESUME_COMPACTION_COMPACT_ANSWER_EN = "Compact and continue";

export function formatClaudeResumeCompactionQuestion(input: {
  readonly ageMinutes: number;
  readonly estimatedTokens: number;
}): string {
  const ageLabel =
    input.ageMinutes >= 60
      ? `${Math.floor(input.ageMinutes / 60)} h ${input.ageMinutes % 60} min`
      : `${input.ageMinutes} min`;
  return `Esta sesión tiene ${ageLabel} y usa ${formatEsTokenCount(input.estimatedTokens)} tokens. ¿La compactamos antes de continuar?`;
}

function formatEsTokenCount(value: number): string {
  const digits = Math.max(0, Math.trunc(value)).toString();
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

const CLAUDE_RESUME_COMPACTION_QUESTION_PATTERN =
  /^Esta sesión tiene (?:\d+ h \d+ min|\d+ min) y usa \d{1,3}(?:\.\d{3})* tokens\. ¿La compactamos antes de continuar\?$/u;
const CLAUDE_RESUME_COMPACTION_QUESTION_PATTERN_EN =
  /^This session is (?:\d+h \d+m|\d+m) old and uses \d{1,3}(?:,\d{3})* tokens\. Compact it before continuing\?$/u;

export function isClaudeResumeCompactionQuestion(question: string): boolean {
  return (
    CLAUDE_RESUME_COMPACTION_QUESTION_PATTERN.test(question) ||
    CLAUDE_RESUME_COMPACTION_QUESTION_PATTERN_EN.test(question)
  );
}

export function isClaudeResumeCompactionQuestionKey(question: string): boolean {
  return (
    isClaudeResumeCompactionQuestion(question) ||
    question === CLAUDE_RESUME_COMPACTION_QUESTION_HEADER ||
    question === CLAUDE_RESUME_COMPACTION_QUESTION_HEADER_EN
  );
}

export function isClaudeResumeCompactionNeverAnswer(answer: unknown): boolean {
  return (
    answer === CLAUDE_RESUME_COMPACTION_NEVER_ANSWER ||
    answer === CLAUDE_RESUME_COMPACTION_NEVER_ANSWER_EN
  );
}

export function isClaudeResumeCompactionCompactAnswer(answer: unknown): boolean {
  return (
    answer === CLAUDE_RESUME_COMPACTION_COMPACT_ANSWER ||
    answer === CLAUDE_RESUME_COMPACTION_COMPACT_ANSWER_EN
  );
}
